"use client";
import { useMyAccount, useMyAccountPhoto } from "@/lib/my-account/hooks";
import { MainAppLayoutMenuLink, MainAppLayoutProfileMenu, useLogoutDialogStore } from "@osn/react-components";

export default function ProfileMenu() {
  const { data: photo } = useMyAccountPhoto();
  const { data: account } = useMyAccount();
  const openLogoutDialog = useLogoutDialogStore((state) => state.open);
  const name = account ? `${account.firstName} ${account.lastName}`.trim() : undefined;

  return (
    <MainAppLayoutProfileMenu name={name} photo={photo ?? undefined}>
      <MainAppLayoutMenuLink href="/personal-info" icon="fa-user">
        Profile
      </MainAppLayoutMenuLink>
      <MainAppLayoutMenuLink href="/security" icon="fa-shield-halved">
        Security
      </MainAppLayoutMenuLink>
      <MainAppLayoutMenuLink href="/manageCommsPreferences" icon="fa-bell">
        Notifications
      </MainAppLayoutMenuLink>
      <MainAppLayoutMenuLink onClick={openLogoutDialog} icon="fa-arrow-right-from-bracket">
        Logout
      </MainAppLayoutMenuLink>
    </MainAppLayoutProfileMenu>
  );
}
